import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface Tenant { readonly id: string; readonly tenantCode: string; readonly displayName: string; readonly recordStatusCode: string; }

export function TenantListPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<Tenant[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: Tenant[] }>('/platform/tenants', { token })
      .then((r) => { if (alive) setRows(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('tenants.list.loading')}</p>;
  return (
    <main aria-label="tenant-list">
      <h1>{t('tenants.list.title')}</h1>
      <Link to="/admin/tenants/new" role="link">{t('tenants.list.new')}</Link>
      <table aria-label="tenants-table">
        <thead><tr><th>{t('tenants.list.col.code')}</th><th>{t('tenants.list.col.name')}</th><th>{t('tenants.list.col.status')}</th><th>{t('tenants.list.col.actions')}</th></tr></thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>{row.tenantCode}</td>
              <td>{row.displayName}</td>
              <td>{row.recordStatusCode}</td>
              <td><Link to={`/admin/tenants/${row.id}/edit`}>{t('tenants.list.edit')}</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
